// extracted by mini-css-extract-plugin
export default {"z-chip__container":"z-chips_z-chip__container__sGXlH","z-chip":"z-chips_z-chip__4zYzJ","z-chip__close":"z-chips_z-chip__close__oNp+R"};